/* eslint react/no-array-index-key:0 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import {
  prop, pipe, find, propEq,
} from 'ramda';

import Layout from '@/components/Layout';
import { contactItems } from '@/utils/consts';
import { useContentByLang, useMobileDetect } from '@/utils/hooks';
import ContactForm from '@/components/ContactForm';

import AddressInfo from './AddressInfo';
import {
  Title,
  Header,
  Menu,
  Wrap,
  MenuItem,
  Introduction,
  InvestorProfile,
  Wrapper,
  SubTitle,
  Text,
  ListItem,
  List,
} from './styles';

const Contacts = ({ pageContext, uri }) => {
  const content = useContentByLang(pageContext);
  const { t } = useTranslation(['app', 'contact']);
  const isMobile = useMobileDetect();

  return (
    <Layout uri={uri}>
      <Header>
        <Title>{isMobile ? pipe(find(propEq('link', uri)), prop('title'), t)(contactItems) : t('contact')}</Title>
        <Menu>
          {contactItems.map(({ title, link }) => (
            <Wrap key={link} selected={uri === link}>
              <MenuItem to={link}>
                {t(title)}
              </MenuItem>
            </Wrap>
          ))}
        </Menu>
      </Header>
      {content.introduction.map((text, index) => (
        <Introduction key={index} amount={content.introduction.length}>{text}</Introduction>
      ))}
      {prop('additional', content) && (
        <InvestorProfile>
          {content.additional.map((item, index) => (
            <Wrapper key={index}>
              <SubTitle>{item.title}</SubTitle>
              <Text>{item.description}</Text>
              {prop('items', item) && (
                <List>
                  {item.items.map((text, textIndex) => (
                    <ListItem key={textIndex}>{text}</ListItem>
                  ))}
                </List>
              )}
            </Wrapper>
          ))}
        </InvestorProfile>
      )}
      <ContactForm id={content.id} />
      <AddressInfo
        mail={content.mail}
        contact={content.contact}
        support={content.support}
        visit={content.visit}
      />
    </Layout>
  );
};

Contacts.propTypes = {
  pageContext: PropTypes.objectOf(PropTypes.any).isRequired,
  uri: PropTypes.string.isRequired,
};

export default Contacts;
